import LabeledSelect from './LabeledSelect'
import { debounce, isEmpty } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { getDynamicSearch, getInfoFor } from '../../redux/sagas/requests/searchService'
import {
  UI_FOCUSED_TYPE_BRAND,
  UI_FOCUSED_TYPE_CATEGORY,
  UI_FOCUSED_TYPE_PAGE,
  UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN,
} from '../../pages/dynamicUi/constants'


//todo update this component
const DynamicSearchSelect = ({
                               label, value, onChange, placeholder = 'Search Brands', type = UI_FOCUSED_TYPE_BRAND,normalCampaignsOnly = false,
                               emptyMsg = 'No data', extData, ...props
                             }) => {
  let isMounted = true

  //todo search a better way to load default values
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    if (extData && !value && !isFetching && onChange) {

      setIsFetching(true)
      getInfoFor(extData, type).then((resp) => {
        if(isMounted){
          setIsFetching(false)
          onChange(resp.data)
        }else{
        }

      }).catch((err) => {
        if(isMounted){
          setIsFetching(false)
        }

      })

    }

  }, [extData, type])

  useEffect(()=>{


    return () => {
      isMounted = false
    }
  }, [])


  // noinspection JSCheckFunctionSignatures
  const debouncedSearch = useCallback(
    debounce((inputText, callback) => {
      handleSearch({input: inputText, type, normalCampaignsOnly}).then((options) => callback(options))
    }, 500),
    [type],
  )


  return (
    <LabeledSelect label={label}
                   value={value}
                   getOptionLabel={(option) => option.name ? option.name : option.title}
                   loading={isFetching}
                   isDisabled={isFetching}
                   getOptionValue={(option) => option.id} placeholder={placeholder}
                   onChange={onChange} emptyMsg={emptyMsg} {...props} loadOptions={debouncedSearch} />
  )


}

export default DynamicSearchSelect

const handleSearch = ({input, type, normalCampaignsOnly, skipDefaultPages = true}) => {
  if (isEmpty(input)) {
    return Promise.resolve([])
  }

  return getDynamicSearch(input, type, normalCampaignsOnly).then((response) =>
    (type === UI_FOCUSED_TYPE_PAGE ? skipDefaultPages ? response.data.data.filter((p)=>p.deletable) : response.data.data :
      type === UI_FOCUSED_TYPE_CATEGORY ? response.data["Categories"] :
      type === UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN ? response.data["jeevee_product_bundles"] :
        response.data) ?? [],
  )

}
